import { OpenPageId } from 'utils/withProgressForm';

export function handleValuesParams<T = any>(data: Partial<Record<OpenPageId, any>>): T {
    return Object.values(data).reduce(
        (result, stepParams) => (typeof stepParams !== 'string' ? Object.assign(result, stepParams) : result),
        {}
    );
}
